import { render, staticRenderFns } from "./51.vue?vue&type=template&id=06bfa8a2&scoped=true&"
var script = {}
import style0 from "./51.vue?vue&type=style&index=0&id=06bfa8a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bfa8a2",
  null
  
)

export default component.exports